const initSelectorDistributors = () => {
    const tabArray = document.querySelectorAll(".tab");
    const distributosrCardsBox = document.querySelector(".distributors-decks");
    if (tabArray && tabArray.length > 0) {
        tabArray.forEach((tab) => {
            tab.addEventListener("click", () => {
                const selectorSpotActive = tab.getAttribute("data-id");
                // #region Distributors Selector
                if (!tab.classList.contains("active")) {
                    for (let i = 0; i < tabArray.length; i++) {
                        tabArray[i].classList.remove("active");
                    }
                    tab.classList.toggle("active");
                    // #endregion
                    // #region Distributors Box Cards Selector
                    const distributorCard = distributosrCardsBox.querySelector(`.card-distributor-box[data-id='${selectorSpotActive}']`);
                    distributosrCardsBox.querySelectorAll(".card-distributor-box").forEach(box => box.classList.remove("active"));
                    if (!distributorCard) {
                        fetchDistributorsCards(selectorSpotActive).then((response => {
                            response.text().then(result => {
                                if (result != null && result.trim() != "") {
                                    // Initialize the DOM parser
                                    const parser = new DOMParser();
                                    // Parse the text and convert it into HTML
                                    const parsedHTML = parser.parseFromString(result, "text/html");
                                    const parsedDistributosrCardsBox = parsedHTML.querySelector(".card-distributor-box");
                                    distributosrCardsBox.append(parsedDistributosrCardsBox);
                                }
                            });
                        }));
                    }
                    else {
                        distributorCard.classList.add("active");
                    }
                    // #endregion
                }
            });
        });
    }
};
const fetchDistributorsCards = (distributosId) => {
    const lang = document.querySelector('html').getAttribute('lang');
    const fetchUrl = `/${lang}/distributors/GetDistributors`;
    return fetch(fetchUrl, {
        method: "post",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        //make sure to serialize your JSON body
        body: JSON.stringify({
            areaId: distributosId
        })
    });
};
